<template>
  <div>
      <v-form ref="formProjectTasks" v-model="formProjectTasks" class="px-2 py-2">
        <p v-if="layout === 'edit'" class="text-h5">{{ languageData.updateTask }}</p>
        <p v-else class="text-h5">{{ languageData.createTask }}</p>
        <v-text-field
          outlined
          no-details
          :rules="rules.title"
          :placeholder="languageData.taskTitle"
          :label="languageData.taskTitle"
          v-model="task.title"                
        ></v-text-field>
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="task.executionDate"
                :label="languageData.tasks.executionDay"
                prepend-inner-icon="mdi-calendar"
                readonly
                :rules="rules.executionDay"
                v-bind="attrs"
                v-on="on"
                outlined
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="task.executionDate"
              no-title
              scrollable
              outlined
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="menu = false"
            >
              {{ languageData.cancel }}
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="$refs.menu.save(task.executionDate)"
            >
              {{ languageData.btnAgreeText }}
            </v-btn>
          </v-date-picker>
        </v-menu>
        <v-textarea
          outlined
          :rules="rules.description"
          :label="languageData.taskDescription"
          v-model="task.description"
          rows="6">
        </v-textarea>
        <v-btn color="primary"
          @click="createOrUpdateProjectTask"
          :loading="dataSaveIsFetching"
        >
          {{ languageData.saveBtn }}
        </v-btn>
      </v-form>
  </div>
</template>


<script type="text/javascript">

import { mapActions, mapState } from "vuex";
import eventBus from "../../../event-bus/eventBus";
import handleFormError from "../../../helpers/handleFormError";
import taskStatusTypes from "../enums/taskStatusTypes";

export default {
  name: "ProjectTasksForm",
  props: {
    taskId: Number,
    layout: String,
    selectedProjectId: Number,
  },
  components: {
  },
  data() {
    return {
      task: {
        title: '',
        description: '',
        status: 0,
        projectId: null,
      },
      menu: false,
      menuTime: false,
      status: [],
      formProjectTasks: false,
      validForm: false,
      rules: {},
      menu1: false,
      menu2: false,
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: null,
        text: null,
        corner: null,
        timeout: 7500,
        title: null,
        visible: false
      },
    }
  },
  computed: {
    ...mapState("saveProjectTask", {
      isShowProjectTaskModal: state => state.isShowProjectTaskModal,
      isProjectTaskSave: state => state.isProjectTaskSave,
      dataSaveIsFetching: state => state.dataSaveIsFetching
    }),

   
  },
  methods: {
      ...mapActions("saveProjectTask", ["storeProjectTask", "updateVisibleModalProjectTask"]),
      ...mapActions("updateProjectTask", ["updateProjectTask"]),
      createOrUpdateProjectTask() {
        let data = this.task;
        let id = data.id;
        delete data.executionTime;
        this.rules = {};
        this.$refs.formProjectTasks.resetValidation();

        if(this.layout === "edit") {
          this.updateProjectTask({creds: {id, data}});
        } else {
          this.storeProjectTask({ creds: { data, projectId: this.selectedProjectId } });
        }
      },
      getSnackbarSuccess: function(title, message) {
      this.snackbar = {
        color: "success",
        icon: "check_circle",
        mode: "multi-line",
        position: "top",
        timeout: 7500,
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
  
  },
  mounted() {
    if(this.layout === "edit") {
      taskStatusTypes.updateLanguage(this.languageData);
      this.status = taskStatusTypes.data;
    }
    eventBus.$on("saveProjectTaskFailure", (errorsReceive) => {
      this.rules = handleFormError(errorsReceive);
      this.validForm = this.$refs.formProjectTasks.validate();
    });
      eventBus.$on("setProjectTaskFormData", (data) => {
      this.task = data;
      this.task.executionDate = data.execution_day.split(' ')[0];
      this.task.executionTime = data.execution_day.split(' ')[1];
    });
    eventBus.$on("clearProjectTaskFormModal", () => {
      this.task = {
        titile: null,
        description: null,
        status: 0,
        executionDate: null,
        executionTime: null,
      };
    });
   
  }
}
</script>